import React from "react";
import AutoTyping from "react-auto-typing";
import operationImage from "../../../assets/operation-management.jpg";
import technicianImage from "../../../assets/technician-empowerment.jpg";
import customerImage from "../../../assets/customer-engagement.png";
import contractImage from "../../../assets/contract-management.png";

const FeaturesOnServices = () => {
  return (
    <div className="cubix-feature-section-wrapper">
      <div className="section-title">
        <h1 className="title">Key Features of Cubix</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Features"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={operationImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Comprehensive Inventory Management</h1>
            <ul className="main-list">
              <li>
                <h6>Centralized Control Hub</h6>
                <ul className="inner-list">
                  <li>
                    Manage all aspects of your warehouse operations from a
                    single, intuitive platform. Track inventory levels, manage
                    locations, and oversee product movements in real-time,
                    allowing for quick resolutions and enhanced accuracy.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Smart Picking and Packing</h6>
                <ul className="inner-list">
                  <li>
                    Optimize order fulfillment with intelligent picking lists
                    that prioritize efficiency and accuracy. Cubix uses
                    algorithms to streamline the picking process, ensuring that
                    your team can fulfill orders quickly and correctly.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Advanced Inventory Forecasting</h6>
                <ul className="inner-list">
                  <li>
                    Utilize advanced analytics to forecast inventory needs based
                    on historical data and market trends. Reduce stockouts and
                    overstock situations by making informed purchasing
                    decisions.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Workforce Optimization</h1>
            <ul className="main-list">
              <li>
                <h6>Real-Time Task Management</h6>
                <ul className="inner-list">
                  <li>
                    Assign tasks and monitor progress in real-time, ensuring
                    that your workforce remains productive and engaged. Cubix
                    helps you balance workloads efficiently, reducing downtime
                    and boosting team morale.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Mobile Workforce Access</h6>
                <ul className="inner-list">
                  <li>
                    Equip your team with mobile capabilities to manage
                    inventory, update stock levels, and communicate seamlessly
                    from anywhere in the warehouse, enhancing operational
                    flexibility.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={technicianImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={customerImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Compliance and Quality Control</h1>
            <ul className="main-list">
              <li>
                <h6>Inventory Audits Made Easy</h6>
                <ul className="inner-list">
                  <li>
                    Simplify inventory audits with automated scheduling and
                    digital checklists. Ensure that your processes adhere to
                    regulatory standards and improve accuracy in reporting.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Quality Assurance Protocols</h6>
                <ul className="inner-list">
                  <li>
                    Implement quality checks at every stage of the inventory
                    process, from receiving shipments to order fulfillment,
                    ensuring high standards and reducing returns.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Integration and Scalability</h1>
            <ul className="main-list">
              <li>
                <h6>Seamless Software Integration</h6>
                <ul className="inner-list">
                  <li>
                    Integrate Cubix with your existing ERP and other business
                    systems to create a unified operational environment. This
                    integration streamlines data flow and enhances overall
                    efficiency.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Scalable Solutions</h6>
                <ul className="inner-list">
                  <li>
                    Whether you’re expanding your product line or increasing
                    warehouse capacity, Cubixis designed to grow with you. Our
                    scalable architecture ensures that your system can adapt to
                    evolving business needs.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={contractImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesOnServices;
